import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiPlus, FiX } from "react-icons/fi";

function DashboardGroupTop({
  totalGroups,
  selectedStatus,
  onStatusChange,
  onStatusClear,
  onSearch,
  onAddGroup
}) {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div className="flex items-center space-x-4">
        <h2 className="text-2xl font-semibold text-gray-800">Groups</h2>
        <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm font-medium">
          {totalGroups} total
        </span>
      </div>

      <div className="flex items-center space-x-4">

        <motion.button
          onClick={onAddGroup}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        >
          <FiPlus className="w-5 h-5" />
          <span>Add Group</span>
        </motion.button>
      </div>

      {/* Status Tags */}
      <AnimatePresence>
        {selectedStatus && (
          <motion.div
            initial={{ opacity: 0, scale: 0.9, x: -10 }}
            animate={{ opacity: 1, scale: 1, x: 0 }}
            exit={{ opacity: 0, scale: 0.9, x: -10 }}
            className="flex items-center gap-2 bg-blue-50 px-3 py-1.5 rounded-lg"
          >
            <span className="text-sm text-blue-700 font-medium">
              {selectedStatus}
            </span>
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={onStatusClear}
              className="text-blue-600 hover:text-blue-700"
            >
              <FiX className="w-4 h-4" />
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default DashboardGroupTop;
